import { render, staticRenderFns } from "./turno.vue?vue&type=template&id=22bd463b&scoped=true&"
import script from "./turno.vue?vue&type=script&lang=js&"
export * from "./turno.vue?vue&type=script&lang=js&"
import style0 from "./turno.vue?vue&type=style&index=0&id=22bd463b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd463b",
  null
  
)

export default component.exports